import { Modal, Pressable, View } from 'react-native';
import { colors, formatTime, pick, statusLabels, type ApiProduct, type ProductStatus } from '@hogar/shared';
import { Button, Dot, Txt, notice, useT, showProblem } from './ui';
import { api } from '../lib/api';
import { useAction } from '../lib/session';

/** For dots and icons. */
export const statusColor: Record<ProductStatus, string> = { good: colors.ok, low: colors.warning, out: colors.danger };
/** For words. */
export const statusTextColor: Record<ProductStatus, string> = { good: colors.okText, low: colors.warningText, out: colors.dangerText };

/** Pick one of the three shared statuses. The last change wins and records who made it. */
export function StatusSheet({ product, onClose, onEdit }: { product: ApiProduct | null; onClose: () => void; onEdit: (p: ApiProduct) => void }) {
  const { t, lang } = useT();
  const act = useAction();
  return (
    <Modal visible={!!product} transparent animationType="slide" onRequestClose={onClose}>
      <Pressable style={{ flex: 1, backgroundColor: 'rgba(30,40,35,0.35)', justifyContent: 'flex-end' }} onPress={onClose}>
        <Pressable style={{ backgroundColor: colors.background, borderTopLeftRadius: 22, borderTopRightRadius: 22, padding: 18, paddingBottom: 30, gap: 10, width: '100%', maxWidth: 560, alignSelf: 'center' }}>
          {product && (
            <>
              <Txt weight="semibold" size={20}>
                {pick(product.name, lang)}
              </Txt>
              {product.statusByName && product.statusAt ? (
                <Txt size={13} color={colors.textMuted}>
                  {t('changedBy', { name: product.statusByName, when: formatTime(product.statusAt) })}
                </Txt>
              ) : null}
              {(['good', 'low', 'out'] as ProductStatus[]).map((st) => {
                const selected = product.status === st;
                return (
                  <Pressable
                    key={st}
                    onPress={() => {
                      onClose();
                      act(() => api('POST', `/products/${product.id}/status`, { status: st })).catch(() => showProblem(t('errGeneric'), lang));
                    }}
                    style={{ flexDirection: 'row', alignItems: 'center', gap: 12, minHeight: 56, borderRadius: 14, paddingHorizontal: 16, backgroundColor: selected ? colors.primarySoft : colors.card, borderWidth: 1.5, borderColor: selected ? colors.primary : colors.cardBorder }}
                  >
                    <Dot color={statusColor[st]} />
                    <Txt weight="medium" size={17}>
                      {statusLabels[st][lang]}
                    </Txt>
                  </Pressable>
                );
              })}
              <View style={{ flexDirection: 'row', gap: 10, marginTop: 4 }}>
                <Button label={t('edit')} variant="outline" onPress={() => onEdit(product)} style={{ flex: 1 }} />
                <Button label={t('back')} variant="outline" onPress={onClose} style={{ flex: 1 }} />
              </View>
            </>
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
}
